<template>
  <div class="mt-4 text-black tab-content">
    <v-col class="flex-wrap" cols="12">
      <div class="mt-4 mb-3" style="font-size: 32px">
        General Settings
      </div>
    </v-col>

    <v-col class="flex-wrap" cols="12">
      <div class="card">
        <v-layout class="d-flex flex-wrap align-center justify-space-between">
          <v-col>
            <div
              class="text-caption font-weight-medium text-uppercase text-truncate"
            >
              Workflow Status
            </div>
            <div>(Set to completed to lock for changes)</div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="2"
            class="
              d-flex
              text-caption
              font-weight-medium
              text-uppercase text-truncate text-center align-center
            ">
            <v-tooltip location="bottom" v-if="!isProjectOwner">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" size="20" color="red-lighten-2">mdi-information-outline</v-icon>
              </template>
              <span>Workflow status can only be updated by the project owner.</span>
            </v-tooltip>
            <v-select
              flat
              variant="solo"
              hide-details
              density="compact"
              class="rounded-lg status-select flex-shrink-0"
              v-model="status"
              :items="statuses"
              :disabled="loadingState || !isProjectOwner"
              @update:model-value="updateWorkflowStatus"
            ></v-select>
          </v-col>
        </v-layout>
      </div>
    </v-col>
    <v-col class="flex-wrap" cols="12">
      <div class="card">
        <v-layout class="d-flex flex-wrap align-center justify-space-between">
          <v-col>
            <div
              class="text-caption font-weight-medium text-uppercase text-truncate"
            >
              Applicon Export
            </div>
            <div>(Enable Applicon export format)</div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="2"
            class="
              d-flex
              text-caption
              font-weight-medium
              text-uppercase text-truncate text-center align-center
            ">
            <v-select
              flat
              variant="solo"
              hide-details
              density="compact"
              class="rounded-lg status-select flex-shrink-0"
              v-model="appExport"
              :items="appExports"
              :disabled="loadingState || $store.state.isWorkflowDisabled"
              @update:model-value="updateAppExportStatus"
            ></v-select>
          </v-col>
        </v-layout>
      </div>
    </v-col>
  </div>
</template>

<script>
import workflowApi from '@/api/workflowApi'
import { mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      statuses: [ // Workflow Status
        { value: 0, title: 'In Progress' },
        { value: 2, title: 'Completed' }
      ],
      appExports: [ // Applicon Export Enable/Disable
        { value: 0, title: 'Disabled' },
        { value: 1, title: 'Enabled' }
      ],
      chatLogOptions: [
        { value: 0, title: 'Disabled' },
        { value: 1, title: 'Enabled' }
      ],
      status: 0,
      appExport: 0
    }
  },

  methods: {
    async updateWorkflowStatus () {
      await workflowApi.updateWorkflowMutation(
        this.$route.params.projectId,
        {
          id: this.$route.params.id,
          status: this.status,
          expectedVersion: this.workflow.version,
          updateNote: {
            action: this.status === 2 ? 'marked workflow as completed' : 'marked workflow as in progress'
          }
        }
      )
      // workaround because domainEvents are cleared after this update
      // as an unwanted side effect of response size optimization
      await this.$store.dispatch('workflow/getWorkflow', this.$route.params)
    },
    async updateAppExportStatus () {
      await workflowApi.updateWorkflowMutation(
        this.$route.params.projectId,
        {
          id: this.$route.params.id,
          canAppliconExport: this.appExport,
          expectedVersion: this.workflow.version,
          updateNote: {
            action: this.appExport === 1 ? 'enabled applicon export' : 'disabled applicon export'
          }
        }
      )
      // workaround because domainEvents are cleared after this update
      // as an unwanted side effect of response size optimization
      await this.$store.dispatch('workflow/getWorkflow', this.$route.params)
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.user,
      workflow: state => state.workflow.workflow,
      projectMemberships: state => state.projectMemberships.projectMemberships,
      sidePanelTab: state => state.sidePanelTab,
      showSidePanel: state => state.showSidePanel
    }),
    ...mapGetters({
      loadingState: 'loading/getLoadingState'
    }),
    // Changing workflow status is a write action. Mirror the backend org-RBAC write gate
    // via the shared getter (SuperAdmin / org OWNER|MEMBER / org creator). Resolve the
    // project's org from the org-gated activeProject (preferred) or the legacy list.
    isProjectOwner () {
      const wfProjectId = this.workflow?.projectId
      const active = this.$store.state.projectMemberships?.activeProject
      const project = active?.id === wfProjectId
        ? active
        : this.projectMemberships?.find(m => m.project?.id === wfProjectId)?.project
      const orgId = project?.organisationId || project?.organisation?.id
      const creatorId = project?.organisation?.userId
      return this.$store.getters['orgMembers/canWriteInOrg'](orgId, creatorId)
    }
  },
  watch: {
    workflow: {
      handler (val) {
        this.status = val.status
        this.appExport = val.canAppliconExport || 0
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.tab-content {
  height: 900px;
}

.status-select {
  width: 160px;
}
</style>
